<script>
export let registrations;


import RegistrationThumb from 'components/views/my/team/thumbs/Registration.svelte';
import ErrorPanelBlock from 'components/elements/ErrorPanelBlock.svelte';

import MsgCard from 'components/elements/MsgCard.svelte';


import tippy from 'sveltejs-tippy';



const paid_props = {
	content: '...',
	placement: 'bottom',
	arrow: false,
};


const amount_outstanding_props = {
	content: '...',
	placement: 'bottom',
	arrow: false,
};


// full registration (for instance) data ... ? ok function (api endpoint)
// import RegistrationInfoModal from './RegistrationInfoModal.svelte';


// export let registrations;

let active_registration_id;
let registration_modal_open = false;


// click outside
function openRegistrationModal(event) {
	// alert('...');
	active_registration_id = event.detail.id;
	registration_modal_open = true;
}


</script>



<style>

#registrations-table {
	
}

</style>



<div class="panel" id="registrations-table">

	<div class="panel-heading">

		<div class="columns is-variable is-2 is-mobile">

			<div class="column is-4-desktop is-5-touch">
				<span>
					Name
				</span>
			</div>

			<div class="column is-2-desktop is-3-touch">
				<span>
					Birth Year
				</span>
			</div>
			
			<div class="column is-3-desktop is-4-touch">
				<span>
					Position
				</span>
			</div>

			<!-- <div class="column is-2-desktop is-hidden-touch">
				<span>
					Paid
				</span>
			</div> -->
			<div class="column is-3-desktop is-hidden-touch">
				<span>
					City
				</span>
			</div>

			<!-- <div class="column is-3-desktop is-4-touch">
				<span>
					Amount Outstanding
				</span>
			</div> -->

		</div>

	</div>

	{#each registrations as registration}
		<RegistrationThumb {registration} on:open_registration_modal={openRegistrationModal} />					
	{/each}


</div>

{#if registrations.length === 0}
	<MsgCard msg_show={true} msg_text={'No Registrations yet!'} msg_type={'error'} msg_forever={true} />
	<!-- <ErrorPanelBlock msg={'No registrations yet.'} /> -->
{/if}


<!-- <RegistrationInfoModal {active_registration_id} bind:registration_modal_open={registration_modal_open} /> -->


<!-- tippy: click to see more -->



